
<div class="padding-20 ui-g" id="c3_searchDistributionList_Modal">

  <app-campaign-3-kontable
  *ngIf="distributionListDetails && show.table"
  id="distributionListDetailsTable"
  [columns] = "[
  { field: 'customer_host_host_id', title: 'campaign.customerId' },
  { field: 'card_no', title: 'campaign.cardNumber' },
  { field: 'cluster_head_code', title: 'campaign.cluster' },
  { field: 'name', title: 'campaign.fullName', filterType: customFilter, filterTemplate: emptyFilter },
  { field: 'telephone', title: 'campaign.phoneNumber', filterType: customFilter, filterTemplate: emptyFilter }
]"

  [paginationType]="paginationType"
  [showInfoButton]="false"
  [showGlobalFilter]="false"
  [showDetailsButton]="false"
  [showRecoverButton]="false"
  [showAddButton]="false"
  [showDeleteButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [service]="srvCampaign3"
  [allowSelectRow]="false"
  [methodsNames]="{ list: 'getDistributionListDetails', sendExtSearchQuery: 'sendExtSearchQuery' }"
  #distributionListDetailsTable>

  <ng-template #emptyFilter data-testid="emptyFilter" let-row>
  </ng-template>

</app-campaign-3-kontable>
 <br />
 <br />
 <br />

</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/view-distribution-list-details/campaign-3-view-distribution-list-details.component.html